export default class ButtonShapeProperties {
    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Public:
    //----------------------------------

    public alpha: number;
    public depthColor: string;
    public fillAlpha: number;
    public fillColor: string;
    public height: number;
    public radius: number;
    public strokeAlpha: number;
    public strokeColor: string;
    public strokeThickness: number;
    public width: number;
    public x: number;
    public y: number;

    //--------------------------------------------------------------------------
    //
    //  Constructor
    //
    //--------------------------------------------------------------------------

    constructor(
        fillColor: string,
        width: number,
        height: number,
        radius = 0,
        alpha = 1,
        strokeColor: string = null,
        strokeThickness = 0,
        fillAlpha = 1,
        strokeAlpha = 0,
        x = 0,
        y = 0
    ) {
        this.fillColor = fillColor;
        this.width = width;
        this.height = height;
        this.radius = radius;
        this.alpha = alpha;
        this.strokeColor = strokeColor;
        this.strokeThickness = strokeThickness;
        this.fillAlpha = fillAlpha;
        this.strokeAlpha = strokeAlpha;
        this.x = x;
        this.y = y;
    }
}
